import { render, staticRenderFns } from "./RastreaBom.vue?vue&type=template&id=b9806070&scoped=true"
import script from "./RastreaBom.vue?vue&type=script&lang=js"
export * from "./RastreaBom.vue?vue&type=script&lang=js"
import style0 from "./RastreaBom.vue?vue&type=style&index=0&id=b9806070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9806070",
  null
  
)

export default component.exports